import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const get = (path, params) => axios.get(`${API}${path}`, { params }).then((r) => r.data);
const post = (path, body) => axios.post(`${API}${path}`, body).then((r) => r.data);
const put = (path, body) => axios.put(`${API}${path}`, body).then((r) => r.data);
const del = (path) => axios.delete(`${API}${path}`).then((r) => r.data);

export const api = {
  models: (params) => get("/models", params),
  createModel: (b) => post("/models", b),
  updateModel: (id, b) => put(`/models/${id}`, b),
  deleteModel: (id) => del(`/models/${id}`),
  offers: (params) => get("/offers", params),
  createOffer: (b) => post("/offers", b),
  updateOffer: (id, b) => put(`/offers/${id}`, b),
  deleteOffer: (id) => del(`/offers/${id}`),
  locations: () => get("/locations"),
  updateLocation: (id, b) => put(`/locations/${id}`, b),
  enquire: (b) => post("/enquiries", b),
  enquiries: () => get("/enquiries"),
};

export const fmtRM = (n) => {
  const v = Number(n || 0);
  return `RM ${v.toLocaleString("en-MY", {
    minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

export const BRAND_LABELS = {
  honda: "Honda",
  proton: "Proton",
  jaecoo: "Jaecoo",
  omoda: "Omoda",
  all: "All Brands",
};

export const useTitle = (t) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  require("react").useEffect(() => {
    document.title = t;
  }, [t]);
};
